import { useEffect } from 'react';

export const useViewportHack = () => {
    useEffect(() => {
        // хак для правильного отображения списка курсов на маленьких телефонах
        // см. https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // используется вместе с миксином viewportMobileFix
        setVHValue();
        window.addEventListener('resize', setVHValue);

        return () => {
            window.removeEventListener('resize', setVHValue);
        };
    }, []);

    const setVHValue = () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
};
